// This file was generated by lezer-generator. You probably shouldn't edit it.
export const eof = 34,
  LiquidText = 1,
  Content = 2,
  LiquidTag = 3,
  Operator = 7,
  ParenthesizedExpression = 8,
  LiquidFilter = 10,
  Filters = 13,
  Boolean = 16,
  Identifier = 17,
  Property = 18,
  Index = 19,
  Number = 21,
  String = 23,
  LiquidObject = 25,
  Text = 28;
